import React from "react";

export const DropDownIcon = ({ ...props }) => {
  return (
    <svg width={9} height={6} viewBox="0 0 9 6" fill="none" {...props}>
      <path
        d="M1 1l3.5 3.5L8 1"
        stroke={props.stroke ? props.stroke : "#01A8CE"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
